<template>
  <div>
    <div class="bg-white p-3">
      <div class="d-flex justify-content-between">
        <MarketplaceLogo />
        <AppNav />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useProgressCardStore } from '~/store/progress-card'
import LendioProgressBar from "~/components/marketplace/subComponents/LendioProgressBar";
import MarketplaceLogo from "~/components/marketplace/MarketplaceLogo";
import { useRootStore } from '~/store/root';
import AppNav from '~/components/AppNav.vue';

export default {
  name: 'MarketplaceMobileNav',
  components: { AppNav, MarketplaceLogo, LendioProgressBar },
  data() {
    return {
      to: 0,
      startProgress: false
    }
  },
  computed: {
    ...mapState(useProgressCardStore, ['marketplaceProgress']),
    progressPercent() {
      return this.startProgress ? this.marketplaceProgress : 0
    }
  },
  mounted() {
    this.startProgress = true
  },
  methods: {
    logout() {
      useRootStore(this.$pinia).logout({
        path: this.$route && this.$route.path
      })

      if (typeof window.logout !== 'undefined') {
        window.logout()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
